export class TypeUtils {
  static toBoolean = value => {
    const stringValue = value?.toString().toLowerCase();

    if (stringValue === "1" || stringValue === "true") return true;

    return false;
  };
}
